<template>
    <div>
        <Calendar v-model="text" :selectionMode="isRange?'range':'single'" :dateFormat="format" :showTime="showTime" 
        :showSeconds="showSeconds" :timeOnly="timeOnly" :showIcon="showIcon" :view="type" :hourFormat="hourFormat" :inline="inline" :showButtonBar="showButtonBar"
        @date-select="dateSelect" @show="show" @hide="hide" @today-click="todayClick" @clear-click="clearClick" @month-change="monthChange" @year-change="yearChange"
        style="width: inherit;height: inherit;" :disabled="readonly" />
    </div>
</template>

<script>
import { computed } from 'vue'
import Calendar from 'primevue/calendar';
import '../../utils/formatDate';

export default {
    name: 'tw-date-picker',
    components: {
        Calendar
    },
    emits: {
        update: null,
        input: null,
        'date-select': null,
        show: null,
        hide: null,
        'today-click': null,
        'clear-click': null,
        'month-change': null,
        'year-change': null,
        'update:modelValue': null
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined || !props.modelValue.length) ? null : new Date(props.modelValue)
            },
            set(value){
                context.emit('update:modelValue', value.pattern('yyyy-MM-dd'))
            }
        })

        const dateSelect = (value) => {
            context.emit('date-select', value)
        }
        const show = () => {
            context.emit('show')
        }
        const hide = () => {
            context.emit('hide')
        }
        const todayClick = (date) => {
            context.emit('today-click', date)
        }
        const clearClick = () => {
            context.emit('clear-click')
        }
        const monthChange = () => {
            context.emit('month-change')
        }
        const yearChange = () => {
            context.emit('year-change')
        }

        return {
            text,
            dateSelect,
            show,
            hide,
            todayClick,
            clearClick,
            monthChange,
            yearChange
        }
    },
    props: {
        modelValue: null,
        isRange: Boolean,
        showTime: Boolean,
        showSeconds: Boolean,
        timeOnly: Boolean,
        showIcon: {
            type: Boolean,
            default: true
        },
        type: String,
        format: String,
        hourFormat: String,
        inline: Boolean,
        showButtonBar: Boolean,
        readonly: {
            type: Boolean,
            default: false
        }
    }
}
</script>